import request from "../../config/axios";

const getNoCacheParams = () => ({
  _lpb_ts: Date.now(),
});

// Service chỉ gọi API Page Builder, không xử lý nghiệp vụ render.
export const getPageSections = (pageSlug) =>
  request.get(`wp-json/custom/v1/page-sections/${pageSlug}`, {
    params: getNoCacheParams(),
  });

export const getPageSeo = (pageSlug) =>
  request.get(`wp-json/custom/v1/page-sections/${pageSlug}/seo`, {
    params: getNoCacheParams(),
  });

export const getSupportedPages = () =>
  request.get("wp-json/custom/v1/page-builder/pages");
